const body = `# Hello, world

This is the first post on the Daily Art blog. I'll use this space to share
behind-the-scenes notes — new features, subject ideas, community drawings
that caught my eye, and any and all thoughts and observations relating to art.

## What to expect

Short, occasional posts. Nothing on a schedule. If you want to know when a
new one goes up, you can bookmark \`/blog\`.

Thanks for being here.
`;

export default body;
